<template>
    <div class="pageBox">
        <Header ref="Header" current='souye'></Header>
        <div class="pageBox_cen">
            <template v-for="(item, index) in list">
                <component :showMarBot="!showTab" :titleText="title" :is="mapComponent[item.name]"
                    @tabChange="tabChange" :content="content" :list='item' :ref="item.name" @itemClick="goProductDetail"
                    @goScroll='goScroll' />
            </template>
        </div>

        <el-dialog :visible.sync="dialogVisible" top="90px" :before-close="handleClose" width="1200px">
            <parameterTable @change="getRjProductInfo" :select_data="select_data" :title="tableTitle"
                :tableList="tableList">
            </parameterTable>
        </el-dialog>

        <Footer></Footer>
    </div>
</template>

<script>
import Header from "@/components/header.vue"
import Footer from "@/components/footer.vue"
import mapComponent from "@/components/mapComponent.js"
import parameterTable from '@/components/c/parameterTable.vue'
import {
    get_banner,
} from "@/api/index.js"
import { get_type_product, get_rj_product_params } from '@/api/product'
export default {
    components: {
        Header,
        Footer,
        parameterTable,
    },
    data() {
        return {
            mapComponent,
            list: [{
                name: 'contactBanner',
                value: '产品轮播图',
            },
            {
                name: 'systemsProduct',
                value: '产品内容',
            }],
            navHidden: false, // 导航栏是否隐藏
            lastScrollTop: 0, // 上一次页面滚动的位置
            currentRoute: '',
            locale: '',
            classId: null,
            title: '',
            content: [],

            dialogVisible: false,
            tableTitle: '',
            tableList: [],
            select_data: {},
            tableQuery: {
                id: null,
                product_id: null,
            },
        }
    },
    created() {
        this.locale = this.$i18n.locale;
        let { id, product_id } = this.$route.query
        if (id) {
            this.classId = id
            this.getProductList()
        }
        if (product_id && id && id == 'bc7b8f90-c1f4-11ef-bcc2-cb1625e53d0d') {
            this.getRjProductInfo()
            this.dialogVisible = true
        }
    },
    computed: {
        showTab() {
            return this.content.length ? this.content[0].children ? true : false : false
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.currentRoute = this.$route.path; // 初始化时获取当前路由地址
        this.$watch('$route', this.onRouteChange);
        var element;
        if (this.nowVibe == 'pc') {
            element = document.documentElement
        } else {
            element = document.documentElement.scrollTop ? document.documentElement : document.body;
        }
        let scrollTop = element.scrollTop;
        if (scrollTop == 0) {
            if (!this.$refs.Header.navHead) {
                this.$refs.Header.headerHover = false;
            }
            this.$refs.Header.headerTrue = false;
        } else {
            this.$refs.Header.headerTrue = true;
            this.$refs.Header.headerHover = true;
        }
        let { index } = this.$route.query
        let type = 9
        if (this.classId == 'b379ce20-c1f4-11ef-bcc2-cb1625e53d0d') {
            type = 9
        } else if (this.classId == 'bc7b8f90-c1f4-11ef-bcc2-cb1625e53d0d') {
            if (index == 1) {
                type = 15
            } else {
                type = 10
            }
        } else if (this.classId == 'c96587b0-c1f4-11ef-bcc2-cb1625e53d0d') {
            type = 11
        } else if (this.classId == 'd2e61610-c1f4-11ef-bcc2-cb1625e53d0d') {
            type = 12
        } else if (this.classId == 'dbc55b60-c1f4-11ef-bcc2-cb1625e53d0d') {
            type = 13
        }
        this.getBannerList(type);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);

    },
    methods: {
        onRouteChange(newRoute, oldRoute) {
            this.currentRoute = newRoute.path; // 更新当前路由地址
            this.$refs.productCen[0].querValue = this.$route.query.value;
            // this.goScroll(this.$route.query.value)
        },
        handleScroll() {
            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
                .scrollTop || 0;
            if (currentScrollTop > this.lastScrollTop) {
                this.navHidden = true;
            } else {
                this.navHidden = false;
            }
            this.lastScrollTop = currentScrollTop;

            // this.$refs.productCen[0].navHidden = this.navHidden;
            if (currentScrollTop == 0) {
                if (!this.$refs.Header.navHead) {
                    this.$refs.Header.headerHover = false;
                } else {
                    this.$refs.Header.mouseoverLi(3);
                }
                this.$refs.Header.headerTrue = false;
            } else {
                this.$refs.Header.headerTrue = true;
                this.$refs.Header.headerHover = true;
            }
        },
        goScroll(e) {
            this.lastScrollTop = e;
            // document.documentElement.scrollTop = e+10;
            var element;
            if (this.nowVibe == 'pc') {
                element = document.documentElement
            } else {
                element = document.documentElement.scrollTop ? document.documentElement : document.body;
            }
            element.scrollTop = e + 10;
            // document.documentElement.scrollTop=0
        },
        // 获取轮播图
        getBannerList(e) {
            let t = this;
            let data = {
                type: e
            }
            get_banner(data).then((res) => {
                console.log(res)
                this.$nextTick(function () {
                    t.$refs['contactBanner'][0].setList(res.data);
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        getProductList() {
            get_type_product({ id: this.classId }).then(res => {
                this.title = res.data.title
                this.content = res.data.list
            })
        },
        goProductDetail(itemData) {
            let { data } = itemData
            let lang = this.locale == 'en' ? 'en' : 'cn'
            if (this.classId == 'bc7b8f90-c1f4-11ef-bcc2-cb1625e53d0d') {
                this.tableQuery = {
                    product_id: data.id,
                    id: this.classId,
                }
                this.getRjProductInfo()
                this.dialogVisible = true
                // this.$router.push({
                //     path: `/${lang}/flexibleEndoscopes`,
                //     query: {
                //         product_id: data.id,
                //         id: this.classId,
                //     }
                // })
            } else {
                this.$router.push({
                    path: `/${lang}/systemsDetail`,
                    query: {
                        product_id: data.id,
                        id: this.classId,
                    }
                })
            }
        },
        tabChange(index) {
            if (this.classId == 'bc7b8f90-c1f4-11ef-bcc2-cb1625e53d0d') {
                if (index == 1) {
                    this.getBannerList(15);
                } else {
                    this.getBannerList(10);
                }
            }
        },

        getRjProductInfo(data = {}) {
            let params = { ...this.tableQuery, ...data }
            get_rj_product_params(params).then(res => {
                this.tableList = res.data.list
                this.tableTitle = res.data.title
                this.select_data = res.data.select_data
            })
        },
        handleClose() {
            this.tableList = []
            this.tableTitle = ''
            this.select_data = {}
            this.dialogVisible = false
        },
    },
}
</script>

<style></style>
<style scoped lang="scss">
.pageBox {
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    .pageBox_cen {
        flex: 1;
    }
}

::v-deep.pageBox .el-dialog__headerbtn .el-dialog__close {
    color: #000000;
}
</style>